import { Card } from "antd";
import { ProfileForm } from "./ProfileForm";

type CreateProfileProps = {
  site_id: string;
  onSuccess?: () => void;
};

export const CreateProfileForm: React.FC<CreateProfileProps> = ({
  site_id,
  onSuccess,
}) => {
  return (
    <Card title="Create New Profile">
      <ProfileForm site_id={site_id} mode="create" onSuccess={onSuccess} />
    </Card>
  );
};
